import { useEffect } from 'react';

import { Col, Form, Input, Row } from 'antd';
import type { FormInstance } from 'antd/es/form';

import { useWorkJourneyContext } from '@src/packages/workJourney/contexts';

import styles from '../../../styles.module.less';

interface RequiredMembersSelectorProps {
  form: FormInstance;
}

/**
 * @description Component to select the required members to start the work journey
 */
const RequiredMembersSelector = ({ form }: RequiredMembersSelectorProps) => {
  const { workJourneyForm, setWorkJourneyForm } = useWorkJourneyContext();

  useEffect(() => {
    form.setFieldsValue({ requiredMembers: workJourneyForm.requiredMembers });
  }, [form, workJourneyForm.requiredMembers]);

  const handleRequiredMembersChange = (rawValue: string) => {
    const parsedValue = rawValue === '' ? 0 : Number(rawValue);
    const requiredMembers = Number.isFinite(parsedValue) ? Math.max(0, Math.trunc(parsedValue)) : 0;

    setWorkJourneyForm({
      ...workJourneyForm,
      requiredMembers,
    });
    form.setFieldsValue({ requiredMembers });
  };

  return (
    <Row className={styles.formSectionRow}>
      <Col xs={24} sm={12} md={12} lg={12} xl={12}>
        <Form.Item
          name="requiredMembers"
          label=""
          rules={[
            { required: true, message: '' },
            {
              type: 'number',
              min: 0,
              transform: value => (value === '' || value == null ? 0 : Number(value)),
            },
          ]}
        >
          <Input
            type="number"
            style={{ width: '100%' }}
            onWheel={e => (e.target as HTMLInputElement).blur()}
            min={0}
            value={workJourneyForm.requiredMembers}
            onChange={e => handleRequiredMembersChange(e.target.value)}
          />
        </Form.Item>
      </Col>
    </Row>
  );
};

export default RequiredMembersSelector;
